module.exports = __webpack_public_path__ + "static/img/preview.0c95584.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/work/dreamworks/preview.jpg
// module id = 1VJu
// module chunks = 1